import {Inject, Injectable, Signal} from "@angular/core";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {Observable, Subject} from "rxjs";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {toSignal} from "@angular/core/rxjs-interop";
import {ajs_WebNavigasjon_DI_TOKEN, AjsWebNavigasjon} from "web-ng2/tjenester/ajs/AjsWebNavigasjon";
import {promiseMedResolvere} from "felles-ng2/støttefunksjoner/promiser";

/** Tjeneste for å deaktivere/reaktivere navigering i applikasjonene.
 * Inntil videre delegeres navigering videre til webNavigasjon fra ajs */
@Injectable({providedIn: 'root'})
export class NavigasjonDeaktivering {

    private readonly _navigasjonDeaktivert = new Subject<boolean>();
    private readonly _navigasjonDeaktivertSomSignal: Signal<boolean>;
    private readonly _navigasjonForhindret = new Subject<void>();

    constructor(@Inject(ajs_WebNavigasjon_DI_TOKEN) private ajsNavigasjon: AjsWebNavigasjon, @Inject(ajs_$rootScope_DI_TOKEN) private ajsRootScope: AjsRootScopeService) {
        //NavigasjonDeaktivering er et singleton - derfor ingen grunn til å avreg lytter
        ajsRootScope.$on(WebNavigasjon.eventer.forhindreNavigasjonAktivert, (event, aktivert: boolean) => {
            this._navigasjonDeaktivert.next(aktivert);
        });
        ajsRootScope.$on(WebNavigasjon.eventer.navigasjonForhindret, () => {
            this._navigasjonForhindret.next();
        });

        this._navigasjonDeaktivertSomSignal = toSignal(this._navigasjonDeaktivert, {initialValue: false});
    }

    get navigasjonForhindret(): Observable<void> {
        return this._navigasjonForhindret;
    }

    get navigasjonDeaktivert(): Observable<boolean> {
        return this._navigasjonDeaktivert;
    }

    get navigasjonDeaktivertSomSignal(): Signal<boolean> {
        return this._navigasjonDeaktivertSomSignal;
    }

    medDeaktivertNavigasjon<T>(arbeid: () => T): T {
        this.aktiverNavigasjon(false);
        try {
            return arbeid();
        } finally {
            this.aktiverNavigasjon(true);
        }
    }

    aktiverNavigasjon(aktivert: boolean): void {
        if (aktivert) this.reaktiverNavigasjon();
        else this.deaktiverNavigasjon();
    }

    deaktiverNavigasjon(): Promise<void> {
        const promise = promiseMedResolvere<void>();
        //$evalAsync for at ajs skal få med seg endringen
        this.ajsRootScope.$evalAsync(() => {
            this.ajsNavigasjon.deaktiverNavigasjon();
            promise.resolve();
        });
        return promise.promise
    }


    reaktiverNavigasjon(): Promise<void> {
        const promise = promiseMedResolvere<void>();
        //$evalAsync for at ajs skal få med seg endringen
        //og - når ikke pakket inn i $evalAsync skriker ng2 om at kode i effect() ikke kan skrive til signals - uten at jeg ser hvor dette problemet oppstår
        this.ajsRootScope.$evalAsync(() => {
            this.ajsNavigasjon.reaktiverNavigasjon();
            promise.resolve();
        });
        return promise.promise
    }

}
